import { basePath } from '../next.config'
import loggingService from './loggingService'

class ApiError extends Error {
	readonly statusCode: number
	constructor(response: Response) {
		super(`HTTP error: status: ${response.status} - ${response.statusText}`)
		this.statusCode = response.status
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const getCurrentProjects = async (
	page: number,
	take: number,
	sort: number,
	filter: number
): Promise<Project[]> => {
	let response: Response

	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/current?page=${page}&take=${take}&sort=${sort}&filter=${filter}`
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error retrieving projects', error, {
			errorType: 'Projects',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const deleteProjectById = async (id: string): Promise<boolean> => {
	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/projects/${id}`, {
			method: 'DELETE',
		})
		if (!response.ok) {
			throw new ApiError(response)
		}
		return response.status == 204
	} catch (error) {
		loggingService('Error deleting a project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const getProject = async (id: string): Promise<Project> => {
	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/projects/${id}`, {
			method: 'GET',
		})

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error retrieving a project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const editProjectDetails = async (
	id: string,
	project: Project
): Promise<boolean> => {
	let response: Response

	const body = {
		Id: project.Id,
		Name: project.Name,
		Description: project.Description,
		IsPublic: project.IsPublic,
	}

	try {
		response = await fetch(`${basePath}/api/musicapp/projects/${id}`, {
			body: JSON.stringify(body),
			method: 'PUT',
		})

		if (!response.ok) {
			throw new ApiError(response)
		}

		return response.status == 204
	} catch (error) {
		loggingService('Error editing project details', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const editTrackNotes = async (
	projectId: string,
	trackId: number,
	notes: string
): Promise<boolean> => {
	let response: Response

	const body = [
		{
			trackId: trackId,
			notes: notes,
		},
	]

	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/tracks`,
			{
				body: JSON.stringify(body),
				method: 'PATCH',
			}
		)
		if (!response.ok) {
			throw new ApiError(response)
		}
		return response.status === 204
	} catch (error) {
		loggingService('Error editing track notes', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const deleteTrackFromProject = async (
	projectId: string,
	trackId: number
): Promise<boolean> => {
	let response: Response

	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/tracks/${trackId}`,
			{
				method: 'DELETE',
			}
		)
		if (!response.ok) {
			throw new ApiError(response)
		}
		return response.status === 204
	} catch (error) {
		loggingService('Error deleting track from project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const deleteTracksFromProject = async (
	projectId: string,
	trackIds: number[]
): Promise<boolean> => {
	let response: Response

	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/tracks`,
			{
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					trackIds,
				}),
			}
		)
		if (!response.ok) {
			throw new ApiError(response)
		}
		return response.status === 204
	} catch (error) {
		loggingService('Error deleting multiple tracks from project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const reorderTracksInProject = async (
	projectId: string,
	trackIds: number[]
): Promise<boolean> => {
	let response: Response

	const body = {
		TrackIds: trackIds,
	}

	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/tracks/order`,
			{
				body: JSON.stringify(body),
				method: 'POST',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return response.status === 200
	} catch (error) {
		loggingService('Error reordering tracks in project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const getCollaborators = async (
	projectId: string
): Promise<ProjectCollaborator[]> => {
	let response: Response
	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/collaborators`,
			{
				method: 'GET',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error getting collaborators', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return []
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const addCollaborator = async (
	projectId: string,
	userId: number,
	shareLink: string
): Promise<boolean> => {
	let response: Response
	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/collaborators`,
			{
				body: JSON.stringify({ UserId: userId, ShareLink: shareLink }),
				method: 'PATCH',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return response.status === 204
	} catch (error) {
		loggingService('Error adding collaborator in project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const deleteCollaborator = async (
	projectId: string,
	userId: number
): Promise<boolean> => {
	let response: Response
	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/collaborators`,
			{
				body: JSON.stringify({ UserId: userId }),
				method: 'DELETE',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return response.status === 204
	} catch (error) {
		loggingService('Error removing collaborator from project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const duplicateProject = async (
	projectId: string,
	userId: number,
	name?: string
): Promise<Project> => {
	let response: Response

	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/duplicate`,
			{
				body: JSON.stringify({ userId: userId, name: name }),
				method: 'POST',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error duplicating a project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const addProject = async (
	name: string,
	description?: string
): Promise<Project> => {
	let response

	try {
		response = await fetch(`${basePath}/api/musicapp/projects`, {
			body: JSON.stringify({ name, description }),
			method: 'POST',
		})

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error adding a project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const addTracksToProject = async (
	projectId: string,
	trackIds: number[]
): Promise<ProjectTrack[]> => {
	let response

	const body = trackIds.map((trackId) => {
		return { trackId: trackId }
	})

	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/tracks`,
			{
				body: JSON.stringify(body),
				method: 'PATCH',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error adding tracks to a project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const sendProject = async (
	projectId: string,
	targetUserEmail: string,
	isOpenToAllOrganisation: boolean
): Promise<ProjectResponse> => {
	let response: Response
	try {
		//add Project to userID
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/send`,
			{
				body: JSON.stringify({ targetUserEmail, isOpenToAllOrganisation }),
				method: 'POST',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		const result = await response.json()
		return {
			...result,
			statusCode: response.status || 200,
		}
	} catch (error) {
		loggingService('Error copying project to account', error, {
			errorType: 'Project API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return error
	}
}
